// extracted by mini-css-extract-plugin
module.exports = {"wishlistIcon":"styles_wishlistIcon__M4KOv"};